import DatabaseService from '@/services/DatabaseService'

const state = {
  schema: null,
  isLoading: false,
  lastUpdated: null,
  sources: null,
  error: null
}

const getters = {
  hasSchema: state => !!state.schema,
  isSchemaLoading: state => state.isLoading,
  schemaAge: state => {
    if (!state.lastUpdated) return null
    return Date.now() - state.lastUpdated
  },
  // Getter pour obtenir les tables
  tables: state => {
    if (!state.schema) return []
    return Object.keys(state.schema)
  },
  // Getter pour obtenir les colonnes d'une table
  getTableColumns: state => tableName => {
    if (!state.schema || !state.schema[tableName]) return []
    return state.schema[tableName]
  },
  hasError: state => !!state.error
}

const mutations = {
  SET_SCHEMA(state, schema) {
    state.schema = schema
    state.lastUpdated = Date.now()
    state.error = null
  },
  
  SET_LOADING(state, loading) {
    state.isLoading = loading
  },
  
  SET_SOURCES(state, sources) {
    state.sources = sources
  },
  
  SET_ERROR(state, error) {
    state.error = error
  },
  
  CLEAR_SCHEMA(state) {
    state.schema = null
    state.lastUpdated = null
    state.sources = null
    state.error = null
  }
}

const actions = {
  loadDatabaseSchema({ commit, state }) {
    // Si le schéma est déjà chargé et récent (moins de 10 minutes), ne pas recharger
    if (state.schema && state.lastUpdated && (Date.now() - state.lastUpdated) < 10 * 60 * 1000) {
      return Promise.resolve(state.schema)
    }

    if (state.isLoading) {
      return Promise.resolve(null)
    }

    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    
    
    // Récupérer le schéma de la dernière source via l'API
    return DatabaseService.getLatestSourceSchema()
      .then(schemaResponse => {
        // Transformer la réponse en format attendu
        const realSchema = {}
        
        if (Array.isArray(schemaResponse)) {
          schemaResponse.forEach(table => {
            const tableName = table.table_name
            const columns = JSON.parse(table.columns) // Parser le JSON string
            realSchema[tableName] = columns
          })
        }
        
        commit('SET_SCHEMA', realSchema)
        
        return realSchema
      })
      .catch(error => {
        console.error('Erreur lors du chargement du schéma:', error)
        commit('SET_ERROR', error.message || 'Erreur lors du chargement du schéma')
        
        // En cas d'erreur, fallback sur un schéma d'exemple
        const fallbackSchema = {
          "notilus": ["bdd", "bddSerial"] // Alias pour Hublot
        }
        
        commit('SET_SCHEMA', fallbackSchema)
        
        return fallbackSchema
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },

  // Action pour forcer le rechargement du schéma
  reloadDatabaseSchema({ commit, dispatch }) {
    commit('CLEAR_SCHEMA')
    return dispatch('loadDatabaseSchema')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}